import axios from "axios";

export const listServiceCentersByCategory = async (categoryId) => {
  return await axios.get(`${process.env.REACT_APP_API}/service-centers?categoryId=${categoryId}`);
};